import PermisosTableros from "../Tableros/PermisosTableros";
// src/components/UsuariosTemporales/AdministrarUsuariosTemporales.jsx
import React, { useEffect, useMemo, useState } from "react";
import DuracionTemporal from "./DuracionTemporal";
import { duracionEnHoras } from "./duracionTemporalUtils";
import { FEATURE_BITS as FB, BITSET_LEN, bitsetPredeterminadoPorRol } from "../../constants/permisos";
import { FIXED_PERMISSION_BITS, forceFixedPermissions } from "../../constants/permisos";
import {
  listarPermisosTemporales,
  // obtenerUsuariosCreadosPorAdmin, // <- si quieres alternar, ya devuelve el shape completo
  actualizarPermisosTemporales,
  eliminarPermisoTemporal,
} from "../../services/usuarioService";
import { usePermisos } from "../../context/PermisosContext";
import { isSuperAdmin } from "../../services/authUtils";
import { limitarPermisosAlCreador } from "../../constants/permissionTemplates";

/* ===== Roles disponibles (texto para mostrar, id para enviar) ===== */
const ROLES = [
  { id: 1, nombre: "Administrador" },
  { id: 2, nombre: "Operador" },
  { id: 3, nombre: "Consultor" },
];
const rolNombrePorId = (id) => ROLES.find((r) => r.id === Number(id))?.nombre ?? "—";

/** ===== Ventanas -> features (VIEW/EDIT) ===== */
const WINDOW_TO_FEATURES = {
  Inicio: ["INICIO_VIEW"],
  Estanques: ["ESTANQUES_VIEW", "ESTANQUES_EDIT"],
  Dispositivos: ["DISPOSITIVOS_VIEW", "DISPOSITIVOS_EDIT"],
  Sensores: ["SENSORES_VIEW", "SENSORES_EDIT"],
  Efectores: ["EFECTORES_VIEW", "EFECTORES_EDIT"],
  Automatización: ["AUTOMATIZACION_VIEW", "AUTOMATIZACION_EDIT"],
  Alarmas: ["ALARMAS_VIEW", "ALARMAS_EDIT"],
  "Usuarios Temporales": ["USUARIOS_TEMP_VIEW", "USUARIOS_TEMP_EDIT"],
  Reportería: ["REPORTERIA_VIEW", "REPORTERIA_EDIT"],
  Configuraciones: ["CONFIGURACIONES_VIEW", "CONFIGURACIONES_EDIT"],
  "Acerca de": ["ACERCA_VIEW"],
  "Contáctanos": ["CONTACTO_VIEW"],
};

const WINDOWS_ORDER = [
  "Inicio",
  "Estanques",
  "Dispositivos",
  "Sensores",
  "Efectores",
  "Automatización",
  "Alarmas",
  "Usuarios Temporales",
  "Reportería",
  "Configuraciones",
  "Acerca de",
  "Contáctanos",
];

/** ===== Pestañas por ventana ===== */
const TABS_BITS = {
  Inicio: [
    { key: "resumen", label: "Resumen", viewBit: FB.INICIO_TAB_RESUMEN_VIEW, editBit: FB.INICIO_TAB_RESUMEN_EDIT },
    { key: "bienvenida", label: "Bienvenida", viewBit: FB.INICIO_TAB_BIENVENIDA_VIEW, editBit: FB.INICIO_TAB_BIENVENIDA_EDIT },
    { key: "misSensores", label: "Mis Sensores", viewBit: FB.INICIO_TAB_MIS_SENSORES_VIEW, editBit: FB.INICIO_TAB_MIS_SENSORES_EDIT },
    { key: "misEstadisticas", label: "Mis Estadísticas", viewBit: FB.INICIO_TAB_MIS_ESTADISTICAS_VIEW, editBit: FB.INICIO_TAB_MIS_ESTADISTICAS_EDIT },
  ],
  Estanques: [
    { key: "tablero", label: "Tablero", viewBit: FB.ESTANQUES_TAB_TABLERO_VIEW, editBit: FB.ESTANQUES_TAB_TABLERO_EDIT },
    { key: "crear", label: "Crear", viewBit: FB.ESTANQUES_TAB_CREAR_VIEW, editBit: FB.ESTANQUES_TAB_CREAR_EDIT },
    { key: "editar", label: "Editar", viewBit: FB.ESTANQUES_TAB_EDITAR_VIEW, editBit: FB.ESTANQUES_TAB_EDITAR_EDIT },
  ],
  Dispositivos: [
    { key: "asistente", label: "Asistente", viewBit: FB.DISPOSITIVOS_TAB_ASISTENTE_VIEW, editBit: FB.DISPOSITIVOS_TAB_ASISTENTE_EDIT },
    { key: "tablero", label: "Tablero", viewBit: FB.DISPOSITIVOS_TAB_TABLERO_VIEW, editBit: FB.DISPOSITIVOS_TAB_TABLERO_EDIT },
    { key: "crear", label: "Crear", viewBit: FB.DISPOSITIVOS_TAB_CREAR_VIEW, editBit: FB.DISPOSITIVOS_TAB_CREAR_EDIT },
    { key: "editar", label: "Editar", viewBit: FB.DISPOSITIVOS_TAB_EDITAR_VIEW, editBit: FB.DISPOSITIVOS_TAB_EDITAR_EDIT },
  ],
  Sensores: [
    { key: "tablero", label: "Tablero", viewBit: FB.SENSORES_TAB_TABLERO_VIEW, editBit: FB.SENSORES_TAB_TABLERO_EDIT },
    { key: "crear", label: "Crear", viewBit: FB.SENSORES_TAB_CREAR_VIEW, editBit: FB.SENSORES_TAB_CREAR_EDIT },
    { key: "editar", label: "Editar", viewBit: FB.SENSORES_TAB_EDITAR_VIEW, editBit: FB.SENSORES_TAB_EDITAR_EDIT },
  ],
  Efectores: [
    { key: "tablero", label: "Tablero", viewBit: FB.EFECTORES_TAB_TABLERO_VIEW, editBit: FB.EFECTORES_TAB_TABLERO_EDIT },
    { key: "crear", label: "Crear", viewBit: FB.EFECTORES_TAB_CREAR_VIEW, editBit: FB.EFECTORES_TAB_CREAR_EDIT },
    { key: "editar", label: "Editar", viewBit: FB.EFECTORES_TAB_EDITAR_VIEW, editBit: FB.EFECTORES_TAB_EDITAR_EDIT },
  ],
  Automatización: [
    { key: "tablero", label: "Tablero", viewBit: FB.AUTOMATIZACION_TAB_TABLERO_VIEW, editBit: FB.AUTOMATIZACION_TAB_TABLERO_EDIT },
    { key: "porSensores", label: "Por Sensores", viewBit: FB.AUTOMATIZACION_TAB_SENSORES_VIEW, editBit: FB.AUTOMATIZACION_TAB_SENSORES_EDIT },
    { key: "porEfectores", label: "Por Efectores", viewBit: FB.AUTOMATIZACION_TAB_EFECTORES_VIEW, editBit: FB.AUTOMATIZACION_TAB_EFECTORES_EDIT },
  ],
  Alarmas: [
    { key: "tablero", label: "Tablero", viewBit: FB.ALARMAS_TAB_TABLERO_VIEW, editBit: FB.ALARMAS_TAB_TABLERO_EDIT },
    { key: "crearAlarma", label: "Crear", viewBit: FB.ALARMAS_TAB_CREAR_VIEW, editBit: FB.ALARMAS_TAB_CREAR_EDIT },
    { key: "administrarAlarmas", label: "Administrar", viewBit: FB.ALARMAS_TAB_ADMIN_VIEW, editBit: FB.ALARMAS_TAB_ADMIN_EDIT },
    { key: "historialAlarmas", label: "Historial y reconocer", viewBit: FB.ALARMAS_TAB_HISTORIAL_VIEW, editBit: FB.ALARMAS_TAB_HISTORIAL_EDIT },
  ],
  "Usuarios Temporales": [
    { key: "crearUsuario", label: "Crear Usuario", viewBit: FB.USUARIOS_TEMP_TAB_CREAR_VIEW, editBit: FB.USUARIOS_TEMP_TAB_CREAR_EDIT },
    { key: "administrar", label: "Administrar Usuarios", viewBit: FB.USUARIOS_TEMP_TAB_EDITAR_VIEW, editBit: FB.USUARIOS_TEMP_TAB_EDITAR_EDIT },
  ],
  Reportería: [
    { key: "lecturas", label: "Lecturas de sensores", viewBit: FB.REPORTERIA_TAB_LECTURAS_VIEW, editBit: FB.REPORTERIA_TAB_LECTURAS_EDIT },
    { key: "operacion", label: "Operación", viewBit: FB.REPORTERIA_TAB_OPERACION_VIEW, editBit: FB.REPORTERIA_TAB_OPERACION_EDIT },
    { key: "auditoria", label: "Auditoría de mi cuenta", viewBit: FB.REPORTERIA_TAB_AUDITORIA_VIEW, editBit: FB.REPORTERIA_TAB_AUDITORIA_EDIT },
    { key: "alarmas", label: "Alarmas", viewBit: FB.REPORTERIA_TAB_ALARMAS_VIEW, editBit: FB.REPORTERIA_TAB_ALARMAS_EDIT },
    { key: "automatizacion", label: "Automatización", viewBit: FB.REPORTERIA_TAB_AUTOMATIZACION_VIEW, editBit: FB.REPORTERIA_TAB_AUTOMATIZACION_EDIT },
    { key: "listaEstanques", label: "Estanques", viewBit: FB.ESTANQUES_TAB_LISTA_VIEW, editBit: FB.ESTANQUES_TAB_LISTA_EDIT },
    { key: "listaDispositivos", label: "Dispositivos", viewBit: FB.DISPOSITIVOS_TAB_LISTA_VIEW, editBit: FB.DISPOSITIVOS_TAB_LISTA_EDIT },
    { key: "listaSensores", label: "Sensores", viewBit: FB.SENSORES_TAB_LISTA_VIEW, editBit: FB.SENSORES_TAB_LISTA_EDIT },
    { key: "listaEfectores", label: "Efectores", viewBit: FB.EFECTORES_TAB_LISTA_VIEW, editBit: FB.EFECTORES_TAB_LISTA_EDIT },
    { key: "listaUsuariosTemp", label: "Usuarios Temporales", viewBit: FB.USUARIOS_TEMP_TAB_LISTA_VIEW, editBit: FB.USUARIOS_TEMP_TAB_LISTA_EDIT },
  ],
  Configuraciones: [
    { key: "perfil", label: "Perfil", viewBit: FB.CONFIGURACIONES_TAB_PERFIL_VIEW, editBit: FB.CONFIGURACIONES_TAB_PERFIL_EDIT },
    { key: "parametros", label: "Parámetros", viewBit: FB.CONFIGURACIONES_TAB_PARAMETROS_VIEW, editBit: FB.CONFIGURACIONES_TAB_PARAMETROS_EDIT },
    { key: "parametrosLista", label: "Parámetros - Lista", viewBit: FB.CONFIGURACIONES_PARAMETROS_LISTA_VIEW, editBit: FB.CONFIGURACIONES_PARAMETROS_LISTA_EDIT },
    { key: "parametroEditar", label: "Parámetro - Editar", viewBit: FB.CONFIGURACIONES_PARAMETRO_EDITAR_VIEW, editBit: FB.CONFIGURACIONES_PARAMETRO_EDITAR_EDIT },
    { key: "firmware", label: "Firmware", viewBit: FB.CONFIGURACIONES_TAB_FIRMWARE_VIEW, editBit: FB.CONFIGURACIONES_TAB_FIRMWARE_EDIT },
    { key: "fwFlash", label: "Firmware - Flashear", viewBit: FB.FIRMWARE_TAB_FLASH_VIEW, editBit: FB.FIRMWARE_TAB_FLASH_EDIT },
    { key: "fwConfig", label: "Firmware - Configurar", viewBit: FB.FIRMWARE_TAB_CONFIG_VIEW, editBit: FB.FIRMWARE_TAB_CONFIG_EDIT },
    { key: "fwOta", label: "Firmware - OTA", viewBit: FB.FIRMWARE_TAB_OTA_VIEW, editBit: FB.FIRMWARE_TAB_OTA_EDIT },
  ],
};

/* ===== Helpers bitset (90 bits) ===== */
const rawEmptyBitset = () => "0".repeat(BITSET_LEN);
const setBit = (bitset, oneBasedPos, value) => {
  const idx = oneBasedPos - 1;
  if (idx < 0 || idx >= BITSET_LEN) return bitset;
  if (FIXED_PERMISSION_BITS.includes(oneBasedPos) && !value) value = true; // nunca apagar bit 1 (Inicio-View)
  return bitset.substring(0, idx) + (value ? "1" : "0") + bitset.substring(idx + 1);
};
const forceBit1 = forceFixedPermissions;
const emptyBitset = () => forceBit1(rawEmptyBitset());
const clampToLength = (s, len = BITSET_LEN) => forceBit1((s || "").padEnd(len, "0").slice(0, len));
const getBit = (bitset, oneBasedPos) => {
  const idx = oneBasedPos - 1;
  if (idx < 0 || idx >= bitset.length) return false;
  return bitset[idx] === "1";
};
const findWindowByViewFeature = (featureKey) => {
  for (const w of Object.keys(WINDOW_TO_FEATURES)) {
    const arr = WINDOW_TO_FEATURES[w] || [];
    if (arr.includes(featureKey)) return w;
  }
  return null;
};

/* ===== Utils de fecha/tiempos ===== */
const fmtFechaLocal = (isoOrDate) => {
  if (!isoOrDate) return "—";
  const d = new Date(isoOrDate);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString();
};
const tiempoRestante = (isoOrDate) => {
  if (!isoOrDate) return "—";
  const fin = new Date(isoOrDate).getTime();
  const now = Date.now();
  const ms = fin - now;
  if (ms <= 0) return "Expirado";
  const totalMin = Math.floor(ms / 60000);
  const dias = Math.floor(totalMin / (60 * 24));
  const horas = Math.floor((totalMin % (60 * 24)) / 60);
  const min = totalMin % 60;
  const partes = [dias ? `${dias}d` : null, horas ? `${horas}h` : null, min ? `${min}m` : null].filter(Boolean);
  return partes.join(" ") || "<1m";
};

const fechaParaInputLocal = (isoOrDate) => {
  if (!isoOrDate) return "";
  const fecha = new Date(isoOrDate);
  if (Number.isNaN(fecha.getTime())) return "";
  const local = new Date(fecha.getTime() - fecha.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 16);
};
const fechaMaximaTemporalLocal = () => fechaParaInputLocal(Date.now() + 10 * 365 * 24 * 60 * 60 * 1000);

const AdministrarUsuariosTemporales = () => {
  const { can, canEdit, bitset: permisosCreador } = usePermisos();
  const esSuper = isSuperAdmin();

  const puedeVer = esSuper || !!can?.("USUARIOS_TEMP_VIEW");
  const puedeEditar = esSuper || !!canEdit?.("USUARIOS_TEMP_EDIT");

  const [usuarios, setUsuarios] = useState([]);
  const [editandoId, setEditandoId] = useState(null);
  const [permisosAbierto, setPermisosAbierto] = useState(false);
  const [busqueda, setBusqueda] = useState("");
  const usuariosFiltrados = useMemo(() => {
    const q = busqueda.trim().toLocaleLowerCase("es");
    if (!q) return usuarios;
    return usuarios.filter((u) => [u.nombre, u.email, u.rolNombre, u.rol,
      u.estaActivo ? "activo" : "inactivo", u.expiracion]
      .some((v) => String(v ?? "").toLocaleLowerCase("es").includes(q)));
  }, [usuarios, busqueda]);

  const [formulario, setFormulario] = useState({
    nombre: "",
    email: "",
    contrasena: "",
    confirmarContrasena: "",
    mostrarContrasena: false,
    rolId: "",
    expiracion: "",
    duracion: "",
    unidadDuracion: "horas",
    endpoint: emptyBitset(),
    estaActivo: false,
  });

  const fetchUsuarios = async () => {
    if (!puedeVer) {
      setUsuarios([]);
      return;
    }
    try {
      // SIEMPRE usamos el listado del controller de permisos (filtra por creador si no eres super)
      const resp = await listarPermisosTemporales();
      const data = resp?.data ?? resp;
      setUsuarios(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error al obtener usuarios temporales:", error);
      setUsuarios([]);
    }
  };

  useEffect(() => {
    fetchUsuarios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [puedeVer]);

  const comenzarEdicion = (u) => {
    setEditandoId(u.id);
    setFormulario({
      nombre: u.nombre || "",
      email: u.email || "",
      contrasena: "",
      confirmarContrasena: "",
      mostrarContrasena: false,
      rolId: u.rolId != null ? String(u.rolId) : "",
      expiracion: fechaParaInputLocal(u.expiracion),
      duracion: "",
      unidadDuracion: "horas",
      endpoint: clampToLength(u.endpoint || emptyBitset()),
      estaActivo: !!u.estaActivo,
    });
    setPermisosAbierto(false);
  };

  const cancelarEdicion = () => {
    setEditandoId(null);
    setFormulario({
      nombre: "",
      email: "",
      contrasena: "",
      confirmarContrasena: "",
      mostrarContrasena: false,
      rolId: "",
      expiracion: "",
    duracion: "",
    unidadDuracion: "horas",
      endpoint: emptyBitset(),
      estaActivo: false,
    });
    setPermisosAbierto(false);
  };

  const ventanasActivas = useMemo(() => {
    const result = {};
    for (const w of WINDOWS_ORDER) {
      const feats = WINDOW_TO_FEATURES[w] || [];
      result[w] = feats.some((fk) => getBit(formulario.endpoint, FB[fk]));
    }
    return result;
  }, [formulario.endpoint]);

  const toggleVentana = (w) => {
    if (!puedeEditar) return;
    const feats = WINDOW_TO_FEATURES[w] || [];
    const estabaActiva = feats.some((fk) => getBit(formulario.endpoint, FB[fk]));
    let next = formulario.endpoint;

    for (const fk of feats) next = setBit(next, FB[fk], !estabaActiva);
    if (estabaActiva && TABS_BITS[w]) {
      for (const t of TABS_BITS[w]) {
        next = setBit(next, t.viewBit, false);
        if (t.editBit) next = setBit(next, t.editBit, false);
      }
    }
    setFormulario((f) => ({ ...f, endpoint: limitarPermisosAlCreador(forceBit1(next), permisosCreador, esSuper) }));
  };

  const toggleFeature = (featureKey) => {
    if (!puedeEditar) return;
    const pos = FB[featureKey];
    const on = getBit(formulario.endpoint, pos);
    let next = setBit(formulario.endpoint, pos, !on);

    if (featureKey.endsWith("_VIEW") && on) {
      const win = findWindowByViewFeature(featureKey);
      if (win && TABS_BITS[win]) {
        for (const t of TABS_BITS[win]) {
          next = setBit(next, t.viewBit, false);
          if (t.editBit) next = setBit(next, t.editBit, false);
        }
      }
    }
    setFormulario((f) => ({ ...f, endpoint: limitarPermisosAlCreador(forceBit1(next), permisosCreador, esSuper) }));
  };

  const activarTodo = () => {
    if (!puedeEditar) return;
    let next = emptyBitset();
    Object.values(FB).forEach((pos) => {
      if (typeof pos === "number") next = setBit(next, pos, true);
    });
    setFormulario((f) => ({ ...f, endpoint: limitarPermisosAlCreador(forceBit1(next), permisosCreador, esSuper) }));
  };

  const limpiarTodo = () => {
    if (!puedeEditar) return;
    setFormulario((f) => ({ ...f, endpoint: emptyBitset() }));
  };

  const toggleTab = (e, bit) => {
    if (!puedeEditar) return;
    e.stopPropagation();
    setFormulario((f) => ({
      ...f,
      endpoint: limitarPermisosAlCreador(forceBit1(setBit(f.endpoint, bit, !getBit(f.endpoint, bit))), permisosCreador, esSuper),
    }));
  };

  const guardarCambios = async () => {
    if (!puedeEditar) return;
    try {
      const original = usuarios.find((u) => u.id === editandoId);
      if (!original) throw new Error("No se encontró el usuario que se está editando.");

      const payload = {};
      if (formulario.nombre.trim() !== (original.nombre || "").trim())
        payload.nombre = formulario.nombre.trim();
      if (formulario.email.trim().toLowerCase() !== (original.email || "").trim().toLowerCase())
        payload.email = formulario.email.trim();
      if (formulario.contrasena) {
        if (formulario.contrasena.length < 8)
          throw new Error("La nueva contraseña debe tener al menos 8 caracteres.");
        if (formulario.contrasena !== formulario.confirmarContrasena)
          throw new Error("La nueva contraseña y su confirmación no coinciden.");
        payload.contrasena = formulario.contrasena;
      }
      if (String(formulario.rolId) !== String(original.rolId ?? ""))
        payload.rolId = parseInt(formulario.rolId, 10);
      if (clampToLength(formulario.endpoint, BITSET_LEN) !== clampToLength(original.endpoint || emptyBitset()))
        payload.endpoint = clampToLength(formulario.endpoint, BITSET_LEN);
      if (!!formulario.estaActivo !== !!original.estaActivo)
        payload.estaActivo = !!formulario.estaActivo;

      const expiracionOriginal = fechaParaInputLocal(original.expiracion);
      if (formulario.duracion !== "") {
        payload.expiracionHoras = duracionEnHoras(formulario.duracion, formulario.unidadDuracion);
      } else if (formulario.expiracion !== expiracionOriginal) {
        const nuevaExpiracion = new Date(formulario.expiracion);
        if (!formulario.expiracion || Number.isNaN(nuevaExpiracion.getTime()))
          throw new Error("Selecciona una fecha de expiración válida.");
        payload.expiracion = nuevaExpiracion.toISOString();
      }

      await actualizarPermisosTemporales(editandoId, payload);
      await fetchUsuarios();
      cancelarEdicion();
    } catch (error) {
      console.error("Error al actualizar usuario:", error);
      const msg = error?.response?.data || error?.message || "No se pudo actualizar el usuario.";
      alert(typeof msg === "string" ? msg : JSON.stringify(msg));
    }
  };

  const eliminarUsuario = async (id) => {
    if (!puedeEditar) return;
    if (!window.confirm("¿Estás seguro de eliminar este usuario?")) return;
    try {
      await eliminarPermisoTemporal(id);
      await fetchUsuarios();
    } catch (error) {
      console.error("Error al eliminar usuario:", error);
      const msg = error?.response?.data || error?.message || "No se pudo eliminar el usuario.";
      alert(typeof msg === "string" ? msg : JSON.stringify(msg));
    }
  };

  if (!puedeVer) {
    return (
      <div className="min-h-[40dvh] flex items-center justify-center bg-neutral-950 text-neutral-300">
        No tienes permisos para ver usuarios temporales.
      </div>
    );
  }

  return (
    <div className="min-h-[50dvh] md:min-h-screen bg-neutral-950 py-6 sm:py-10 px-3 sm:px-4 text-white">
      <div className="max-w-6xl mx-auto bg-neutral-900 rounded-xl shadow-md p-4 sm:p-6">
        <div className="flex items-center justify-between mb-4 sm:mb-6">
          <h3 className="text-xl sm:text-2xl font-bold text-emerald-400">
            Administrar Usuarios Temporales
          </h3>
          {esSuper && (
            <span className="text-xs border border-emerald-500/60 px-2 py-1 rounded text-emerald-300">
              Superadministrador
            </span>
          )}
        </div>

        <input value={busqueda} onChange={(e) => setBusqueda(e.target.value)}
          placeholder="Buscar por nombre, correo, rol, estado o expiración…"
          className="w-full mb-4 p-2.5 rounded bg-neutral-800 border border-emerald-700/50 text-white" />

        {/* Tabla */}
        <div className="overflow-x-auto rounded-lg border border-emerald-700/50">
          <table className="min-w-[1150px] w-full text-xs sm:text-sm">
            <thead className="bg-emerald-900/60 text-white">
              <tr>
                <th className="p-2 sm:p-3 text-left">Nombre</th>
                <th className="p-2 sm:p-3 text-left">Correo</th>
                <th className="p-2 sm:p-3 text-center">Activo</th>
                <th className="p-2 sm:p-3 text-center">Expira</th>
                <th className="p-2 sm:p-3 text-center">Rol</th>
                <th className="p-2 sm:p-3 text-center">Nueva expiración</th>
                <th className="p-2 sm:p-3 text-center">Contraseña</th>
                <th className="p-2 sm:p-3 text-center">Permisos</th>
                <th className="p-2 sm:p-3 text-center">Acciones</th>
              </tr>
            </thead>

            <tbody className="bg-neutral-800 text-white">
              {usuariosFiltrados.map((u) => (
                <tr key={u.id} className="border-t border-emerald-800/40 align-top">
                  {/* Nombre */}
                  <td className="p-2 sm:p-3">
                    {editandoId === u.id ? (
                      <input
                        value={formulario.nombre}
                        onChange={(e) => setFormulario({ ...formulario, nombre: e.target.value })}
                        className="w-full border border-neutral-600 rounded px-2 py-1 bg-neutral-900 text-white"
                        disabled={!puedeEditar}
                      />
                    ) : (
                      <span className="break-words">{u.nombre}</span>
                    )}
                  </td>

                  {/* Correo */}
                  <td className="p-2 sm:p-3">
                    {editandoId === u.id ? (
                      <input
                        value={formulario.email}
                        onChange={(e) => setFormulario({ ...formulario, email: e.target.value })}
                        className="w-full border border-neutral-600 rounded px-2 py-1 bg-neutral-900 text-white"
                        disabled={!puedeEditar}
                      />
                    ) : (
                      <span className="break-words">{u.email}</span>
                    )}
                  </td>

                  {/* Activo */}
                  <td className="p-2 sm:p-3 text-center">
                    {editandoId === u.id ? (
                      <select
                        value={formulario.estaActivo ? "true" : "false"}
                        onChange={(e) =>
                          setFormulario({ ...formulario, estaActivo: e.target.value === "true" })
                        }
                        className="border border-neutral-600 rounded px-2 py-1 bg-neutral-900 text-white w-full sm:w-auto"
                        disabled={!puedeEditar}
                      >
                        <option value="true">Activo</option>
                        <option value="false">Inactivo</option>
                      </select>
                    ) : (
                      <span className={`font-bold ${u.estaActivo ? "text-emerald-400" : "text-red-500"}`}>
                        {u.estaActivo ? "✅ Activo" : "❌ Inactivo"}
                      </span>
                    )}
                  </td>

                  {/* Expira (fecha + tiempo restante) */}
                  <td className="p-2 sm:p-3 text-center whitespace-nowrap">
                    <div className="leading-tight">
                      <div>{fmtFechaLocal(u.expiracion)}</div>
                      <div className="text-[11px] text-neutral-300">{tiempoRestante(u.expiracion)}</div>
                    </div>
                  </td>

                  {/* Rol */}
                  <td className="p-2 sm:p-3 text-center">
                    {editandoId === u.id ? (
                      <select
                        value={formulario.rolId}
                        onChange={(e) => {
                          const nextRol = e.target.value;
                          setFormulario({
                            ...formulario,
                            rolId: nextRol,
                            endpoint: limitarPermisosAlCreador(bitsetPredeterminadoPorRol(nextRol), permisosCreador, esSuper),
                          });
                        }}
                        className="border border-neutral-600 rounded px-2 py-1 bg-neutral-900 text-white"
                        disabled={!puedeEditar}
                      >
                        <option value="">Seleccionar…</option>
                        {ROLES.map((r) => (
                          <option key={r.id} value={r.id}>
                            {r.nombre}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <span>{rolNombrePorId(u.rolId)}</span>
                    )}
                  </td>

                  {/* Nueva fecha de expiración */}
                  <td className="p-2 sm:p-3 text-center">
                    {editandoId === u.id ? (
                      <div className="min-w-[230px] space-y-2 text-left">
                        <DuracionTemporal cantidad={formulario.duracion} unidad={formulario.unidadDuracion}
                          onCantidadChange={duracion => setFormulario(f => ({...f, duracion}))}
                          onUnidadChange={unidadDuracion => setFormulario(f => ({...f, unidadDuracion}))}
                          disabled={!puedeEditar} opcional />
                        <label className="block text-xs">O indicar fecha exacta
                          <input type="datetime-local" max={fechaMaximaTemporalLocal()} value={formulario.expiracion}
                            onChange={e => setFormulario({...formulario, expiracion:e.target.value, duracion:""})}
                            className="w-full border border-neutral-600 rounded px-2 py-1 bg-neutral-900 text-white"
                            disabled={!puedeEditar || formulario.duracion !== ""} />
                        </label>
                      </div>
                    ) : (
                      <span>—</span>
                    )}
                  </td>

                  {/* Nueva contraseña opcional */}
                  <td className="p-2 sm:p-3 text-center">
                    {editandoId === u.id ? (
                      <div className="flex flex-col gap-2 min-w-[190px]">
                        <div className="flex gap-1">
                          <input
                            type={formulario.mostrarContrasena ? "text" : "password"}
                            placeholder="Nueva contraseña"
                            value={formulario.contrasena}
                            onChange={(e) => setFormulario({ ...formulario, contrasena: e.target.value })}
                            className="min-w-0 flex-1 border border-neutral-600 rounded px-2 py-1 bg-neutral-900 text-white"
                            disabled={!puedeEditar}
                            autoComplete="new-password"
                          />
                          <button
                            type="button"
                            onClick={() => setFormulario((f) => ({ ...f, mostrarContrasena: !f.mostrarContrasena }))}
                            className="border border-neutral-600 rounded px-2 bg-neutral-800"
                            title={formulario.mostrarContrasena ? "Ocultar contraseñas" : "Mostrar contraseñas"}
                            disabled={!puedeEditar}
                          >
                            {formulario.mostrarContrasena ? "🙈" : "👁"}
                          </button>
                        </div>
                        <input
                          type={formulario.mostrarContrasena ? "text" : "password"}
                          placeholder="Confirmar contraseña"
                          value={formulario.confirmarContrasena}
                          onChange={(e) => setFormulario({ ...formulario, confirmarContrasena: e.target.value })}
                          className="w-full border border-neutral-600 rounded px-2 py-1 bg-neutral-900 text-white"
                          disabled={!puedeEditar || !formulario.contrasena}
                          autoComplete="new-password"
                        />
                        <span className="text-[10px] text-neutral-400">Vacío = conservar la actual. Una nueva clave cambiará el acceso de esta cuenta temporal.</span>
                      </div>
                    ) : (
                      <span>•••••</span>
                    )}
                  </td>

                  {/* Permisos */}
                  <td className="p-2 sm:p-3">
                    {editandoId === u.id ? (
                      <div className="w-full">
                        <button
                          type="button"
                          onClick={() => puedeEditar && setPermisosAbierto((v) => !v)}
                          className={`w-full sm:w-auto inline-flex items-center justify-between gap-2 border rounded px-3 py-2 text-xs sm:text-sm ${
                            puedeEditar
                              ? "bg-neutral-800 border-neutral-600 hover:bg-neutral-700"
                              : "bg-neutral-800/60 border-neutral-700 cursor-not-allowed"
                          }`}
                        >
                          <span className="font-medium">Permisos (por ventana)</span>
                          {esSuper && <code className="bg-neutral-900 px-2 py-0.5 rounded border border-neutral-700">
                            {formulario.endpoint}
                          </code>}
                          <svg
                            className={`w-4 h-4 opacity-80 transition-transform ${
                              permisosAbierto ? "rotate-180" : ""
                            }`}
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 011.08 1.04l-4.25 4.25a.75.75 0 01-1.06 0L5.21 8.27a.75.75 0 01.02-1.06z" />
                          </svg>
                        </button>

                        {permisosAbierto && (
                          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-3 sm:p-6" role="dialog" aria-modal="true" aria-label="Permisos del usuario temporal">
                          <div className="w-full max-w-6xl max-h-[92vh] overflow-y-auto border border-emerald-700/60 rounded-xl bg-neutral-950 p-4 sm:p-6 shadow-2xl">
                            <h3 className="mb-3 text-lg font-semibold text-emerald-300">Permisos del usuario</h3>
                            <PermisosTableros />
                            <p className="mb-3 text-xs text-neutral-400">“Ventana” controla el acceso general al tablero. Cada sección controla abrir o modificar esa función específica.</p>
                            <div className="flex flex-wrap items-center gap-2 justify-between mb-3">
                              <div className="flex gap-2">
                                <button
                                  type="button"
                                  onClick={activarTodo}
                                  className={`text-xs sm:text-sm rounded px-2 py-1 ${
                                    puedeEditar
                                      ? "bg-emerald-700 hover:bg-emerald-600 text-white"
                                      : "bg-neutral-700 text-neutral-300 cursor-not-allowed"
                                  }`}
                                  disabled={!puedeEditar}
                                >
                                  Activar todo
                                </button>
                                <button
                                  type="button"
                                  onClick={limpiarTodo}
                                  className={`text-xs sm:text-sm rounded px-2 py-1 ${
                                    puedeEditar
                                      ? "bg-neutral-700 hover:bg-neutral-600 text-white"
                                      : "bg-neutral-700 text-neutral-300 cursor-not-allowed"
                                  }`}
                                  disabled={!puedeEditar}
                                >
                                  Limpiar
                                </button>
                              </div>
                              <button
                                type="button"
                                onClick={() => setPermisosAbierto(false)}
                                className="text-xs sm:text-sm bg-emerald-700 hover:bg-emerald-600 text-white rounded px-2 py-1"
                              >
                                Listo
                              </button>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                              {WINDOWS_ORDER.map((w) => {
                                const active = ventanasActivas[w];
                                const tabDefs = TABS_BITS[w] || [];
                                const isInicio = ["Inicio", "Acerca de", "Contáctanos"].includes(w);

                                const wrapperClasses = `rounded-lg border px-3 py-3 transition-colors ${
                                  active
                                    ? "bg-emerald-400/10 border-emerald-500/40"
                                    : "bg-neutral-900/60 border-neutral-700"
                                } ${isInicio || !puedeEditar ? "cursor-default" : "cursor-pointer"}`;

                                return (
                                  <div
                                    key={w}
                                    className={wrapperClasses}
                                    onClick={() => !isInicio && puedeEditar && toggleVentana(w)}
                                    title={
                                      isInicio
                                        ? "Esta ventana siempre está habilitada"
                                        : puedeEditar
                                        ? "Click para activar/desactivar (Ver/Editar)"
                                        : "Sin permiso para editar"
                                    }
                                  >
                                    <div className="flex items-center justify-between mb-2">
                                      <span className="font-medium">{w}</span>
                                      <span className={`text-xs ${active ? "text-emerald-300" : "text-neutral-400"}`}>
                                        {["Inicio", "Acerca de", "Contáctanos"].includes(w) ? "Siempre activo" : active ? "ON" : "OFF"}
                                      </span>
                                    </div>

                                    <div className="mt-1 flex flex-wrap gap-2">
                                      {(WINDOW_TO_FEATURES[w] || []).map((fk) => {
                                        const on = getBit(formulario.endpoint, FB[fk]);
                                        const isInicioView = ["INICIO_VIEW", "ACERCA_VIEW", "CONTACTO_VIEW"].includes(fk);
                                        const label =
                                          fk.endsWith("_VIEW")
                                          ? "Ventana · Abrir"
                                            : fk.endsWith("_EDIT")
                                            ? "Ventana · Modificar"
                                            : fk;
                                        const buttonClasses = `text-xs px-2 py-1 rounded border ${
                                          on
                                            ? "bg-emerald-600/80 border-emerald-500"
                                            : "bg-neutral-800 border-neutral-700"
                                        } ${(!puedeEditar || isInicioView) ? "opacity-60 cursor-not-allowed" : ""}`;

                                        return (
                                          <button
                                            key={fk}
                                            type="button"
                                            className={buttonClasses}
                                            onClick={(e) => {
                                              if (!puedeEditar || isInicioView) return;
                                              e.stopPropagation();
                                              toggleFeature(fk);
                                            }}
                                          >
                                            {label}
                                          </button>
                                        );
                                      })}
                                    </div>

                                    {tabDefs.length > 0 && (
                                      <div className="mt-3 space-y-2">
                                        {tabDefs.map((t) => {
                                          const viewOn = getBit(formulario.endpoint, t.viewBit);
                                          const editOn = t.editBit ? getBit(formulario.endpoint, t.editBit) : false;
                                          const common = (on) =>
                                            `text-[11px] px-2 py-1 rounded border ${
                                              on ? "bg-emerald-600/80 border-emerald-500" : "bg-neutral-800 border-neutral-700"
                                            } ${!puedeEditar ? "opacity-60 cursor-not-allowed" : ""}`;

                                          return (
                                            <div key={t.key} className="flex flex-wrap gap-2">
                                              <button
                                                type="button"
                                                className={common(viewOn)}
                                                onClick={(e) => puedeEditar && toggleTab(e, t.viewBit)}
                                                title={`${t.label}: abrir sección`}
                                                disabled={!puedeEditar}
                                              >
                                                {t.label} · Abrir
                                              </button>
                                              {t.editBit && (
                                                <button
                                                  type="button"
                                                  className={common(editOn)}
                                                  onClick={(e) => puedeEditar && toggleTab(e, t.editBit)}
                                                  title={`${t.label}: modificar sección`}
                                                  disabled={!puedeEditar}
                                                >
                                                  {t.label} · {w === "Reportería" ? "Exportar" : "Modificar"}
                                                </button>
                                              )}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      esSuper ? <code className="text-xs break-words block min-w-[150px]">
                        {clampToLength(u.endpoint || emptyBitset())}
                      </code> : <span className="text-xs">Permisos configurados</span>
                    )}
                  </td>

                  {/* Acciones */}
                  <td className="p-2 sm:p-3">
                    {editandoId === u.id ? (
                      <div className="flex flex-col sm:flex-row gap-2 justify-center">
                        <button
                          onClick={guardarCambios}
                          className={`px-3 py-1.5 rounded text-xs sm:text-sm ${
                            puedeEditar
                              ? "bg-emerald-600 hover:bg-emerald-700 text-white"
                              : "bg-neutral-700 text-neutral-300 cursor-not-allowed"
                          }`}
                          disabled={!puedeEditar}
                        >
                          Guardar
                        </button>
                        <button
                          onClick={cancelarEdicion}
                          className="bg-neutral-600 hover:bg-neutral-700 px-3 py-1.5 text-white rounded text-xs sm:text-sm"
                        >
                          Cancelar
                        </button>
                      </div>
                    ) : (
                      <div className="flex flex-col sm:flex-row gap-2 justify-center">
                        <button
                          onClick={() => puedeEditar && comenzarEdicion(u)}
                          className={`px-3 py-1.5 rounded text-xs sm:text-sm ${
                            puedeEditar
                              ? "bg-yellow-400 hover:bg-yellow-500 text-black"
                              : "bg-neutral-700 text-neutral-300 cursor-not-allowed"
                          }`}
                          disabled={!puedeEditar}
                        >
                          Editar
                        </button>
                        <button
                          onClick={() => puedeEditar && eliminarUsuario(u.id)}
                          className={`px-3 py-1.5 rounded text-xs sm:text-sm ${
                            puedeEditar
                              ? "bg-red-600 hover:bg-red-700 text-white"
                              : "bg-neutral-700 text-neutral-300 cursor-not-allowed"
                          }`}
                          disabled={!puedeEditar}
                        >
                          Eliminar
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}

              {usuarios.length === 0 && (
                <tr>
                  <td colSpan="9" className="text-center py-6 text-neutral-400">
                    No hay usuarios temporales registrados.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdministrarUsuariosTemporales;
